export default "__VITE_ASSET__B1qTu3BY__"